const Switch1 = ({ Name }) => {
  return (<>
    <div className="toggle-switch small-switch">
      <input
        type="checkbox"
        className="toggle-switch-checkbox"
        name={Name}
        id={Name}
      />
      <label className="toggle-switch-label" htmlFor={Name}>
        <span className="toggle-switch-inner" />
        <span className="toggle-switch-switch" />
      </label>
    </div>
  </>)
}

export default Switch1;